__turbopack_context__.v({
  "action": "ProductCommandToaster-module__50z_Jq__action",
  "close": "ProductCommandToaster-module__50z_Jq__close",
  "content": "ProductCommandToaster-module__50z_Jq__content",
  "description": "ProductCommandToaster-module__50z_Jq__description",
  "title": "ProductCommandToaster-module__50z_Jq__title",
  "toast": "ProductCommandToaster-module__50z_Jq__toast",
  "toaster": "ProductCommandToaster-module__50z_Jq__toaster",
});
